import React from "react";
import MobileWrapper from '../../layouts/MobileWrapper';
import { connect } from 'react-redux';
import { Card, WingBlank, WhiteSpace, Modal, List, TextareaItem, Toast, Tabs, DatePicker } from 'antd-mobile';
import { Button, Calendar, Icon } from 'antd';
import { fetchMyAttendanceDetail, fetchMyAttendance } from "../../actions/employee-actions";
import moment from "moment";
import myAttendance from '../../services/Employee/my-attendance-service';
import './style.css'

// const webConfig = require ('../../config.json');
const tabs = [
	// { title: '考勤记录' },
	{ title: '我的考勤' }
];
const iconMap = [
	{ icon: "", title: "" },
	{ icon: "clock-circle-o", title: "迟到" },
	{ icon: "clock-circle", title: "早退" },
	{ icon: "warning", title: "未打卡" },
	{ icon: "close-circle-o", title: "旷工" },
	{ icon: "sync", title: "调休" },
	{ icon: "down-circle-o", title: "正常" }
];

class MobileAttendanceDetail extends React.Component {

	state = {
		currentSelectDate: moment().format('YYYY-MM-DD'),
		currentModalStatus: false,
		on_time: "",
		off_time: "",
		month: new Date(),
	}

	componentWillMount() {
		let date = {
			attendance_date: moment().format('YYYY-MM')
			// calendar_date:this.props.routing.location.pathname.split('/')[3]
		}
		this.setState(date);
		this.props.fetchMyAttendanceDetail(date);
		this.myAttendanceMonthChange(this.state.month)
		setTimeout(() => console.log(this.props.employee), 3000)
	}
	onPanelChange = moment => {
		let date = {
			attendance_date: moment.format('YYYY-MM')
		}
		this.setState(date);
		this.props.fetchMyAttendanceDetail(date);
		this.props.fetchMyAttendance(date)
	}
	dateCellRender = moment => {
		let type = 0;
		this.props.employee.myAttendance.data.forEach(date => {
			if (date.calendar_date === moment.format('YYYY-MM-DD')) {
				if (date.status === 10) {
					type = 6
				}
				else {
					type = date.status;
				}
			}
		})
		return (
			<div>
				<div>
					<Icon type={iconMap[type].icon} style={{ marginLeft: "2px", color: type === 6 ? "" : "red" }} />
				</div>
			</div>
		)
	}
	onSelect = moment => {
		this.setState({
			currentSelectDate: moment.format("YYYY-MM-DD"),
			currentData: 1
		})
		this.props.employee.myAttendance.data.forEach(date => {
			if (date.calendar_date === moment.format('YYYY-MM-DD')) {
				this.setState({
					currentData: {
						...date,
						icon: iconMap[date.calendar_type]
					}
				})
				return;
			}
		})
	}
	customHandle = () => {
		this.setState({
			currentModalStatus: true,
			attendance_date: this.state.currentData.calendar_date,
			schedule_id: this.state.currentData.schedule_id,
			on_time: this.state.currentData.on_time_str,
			off_time: this.state.currentData.off_time_str,
			attendance_status: this.state.currentData.status,
		});
		// this.setState({currentData: this.props.employee.myAttendance[index]});
	}
	onCancel = () => {
		this.setState({
			currentModalStatus: false,
			complaint_content: ""
		});
	}
	handleChange = (event) => {
		this.setState({ complaint_content: event });
	}
	onSubmit = () => {

		if (this.state.complaint_content == null || this.state.complaint_content === "") {
			Toast.fail("请填写申诉描述！", 4);
			return false;
		}
		let posts = {
			complaint_content: this.state.complaint_content,
			attendance_date: this.state.attendance_date,
			schedule_id: this.state.schedule_id,
			on_time: this.state.on_time,
			off_time: this.state.off_time,
			attendance_status: this.state.attendance_status,
		}
		myAttendance.fetchAttendanceComplaint(posts, res => {
			if (res.data.Success) {
				Toast.success("申诉描述操作成功", 4);

				this.setState({ complaint_content: "" });
				this.setState({ currentModalStatus: false });

			} else if (res.data.Errors) {
				Toast.fail(`申诉描述操作失败：${res.data.Errors}`, 4);
			} else {
				Toast.fail(`申诉描述操作失败：${res.data.Message}`, 4);
			}
		}, err => {
		});

	}
	formatDate = (date, type) => {
		const pad = n => n < 10 ? `0${n}` : n;
		const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}`;
		const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;

		if (type === 'time') {
			return `${timeStr}`
		} else {
			return `${dateStr}`
		}
	}
	myAttendanceMonthChange = (val) => {
		let params = {}
		if (val) {
			params.current_record_date = this.formatDate(val, "date")
			this.setState({ management_date: this.formatDate(val, "date"), month: val })
		}
		this.props.fetchMyAttendance(params)
	}

	fetchPreMonthAttendance = () => {
		let preMonth = moment(this.state.month).subtract('months', 1).format("YYYY-MM");
		let params = {};
		params.current_record_date = preMonth;
		this.setState({ management_date: preMonth, month: new Date(preMonth) })
		this.props.fetchMyAttendance(params)
	}

	fetchNextMonthAttendance = () => {
		let nextMonth = moment(this.state.month).add('months', 1).format("YYYY-MM");
		let params = {};
		params.current_record_date = nextMonth;
		this.setState({ management_date: nextMonth, month: new Date(nextMonth) })
		this.props.fetchMyAttendance(params)
	}


	render() {
		const { myAttendanceData } = this.props.employee;

		return (
			<div>
				<Tabs tabs={tabs}
					animated={false}
					initalPage={'t1'}>
					{/* <div> */}
						{/* <div className="calendarDiv">
							<Calendar fullscreen={true}
								dateCellRender={this.dateCellRender}
								onPanelChange={this.onPanelChange}
								onSelect={this.onSelect}
								defaultValue={this.state.defaultDate}
							/>
						</div>
						<div className="attendance-calendar" style={{ border: "1px solid #e5e5e5", borderRadius: "3px", paddingTop: "10px" }}>
							<span style={{ height: "40px", lineHeight: "40px", margin: "0px 5px" }}>注:</span>
							{iconMap.map(icon => (
								<span key={icon.icon} style={{ margin: "6px", fontSize: "14px" }}>
									<Icon type={icon.icon}> {icon.title}</Icon>
								</span>
							))}
						</div> */}
						{/* <div>
							<WingBlank size="lg">
								<WhiteSpace size="lg" />
								<Card>
									<Card.Header
										title="我的考勤"
										extra={<span>{this.state.currentSelectDate && this.state.currentSelectDate}</span>}
									/>
									{this.state.currentData && this.state.currentData !== 1 ?
										<Card.Body>
											<List style={{ backgroundColor: 'white' }} className="picker-list"> */}
												{/*<List.Item extra={this.state.currentSelectDate}>考勤日期</List.Item>*/}
												{/* <List.Item extra={this.state.currentData.should_attendance_time}>应该出勤时间</List.Item>
												<List.Item extra={this.state.currentData.on_time_str}>签到时间</List.Item>
												<List.Item extra={this.state.currentData.off_time_str}>签出时间</List.Item>
												<List.Item extra={this.state.currentData.relaxation_hours}>调休时间</List.Item>
												<List.Item extra={this.state.currentData.overtimes_hours}>加班时间</List.Item>
											</List>

										</Card.Body>
										:
										<Card.Body>
											<div>暂无内容</div>
										</Card.Body>
									}
									<Card.Footer />
								</Card>
								<WhiteSpace size="lg" />
							</WingBlank>
						</div>
						{this.state.currentData &&
							<div style={{ textAlign: "center" }}>
								{Object.keys(this.state.currentData).length > 0 && this.state.currentData.status !== 10 &&
									this.props.user.currentUser.PermissionDict.mobile_attendance_detail.appeal_value
									&& <Button type="primary"
										style={{ width: "120px" }}
										onClick={this.customHandle}>申诉</Button>}
							</div>}
					</div> */}
					<div>
						<List style={{ backgroundColor: 'white' }} className="picker-list my-attendance">
							<span className="pick-pre-month" onClick={this.fetchPreMonthAttendance}>上月</span>
							<DatePicker
								value={this.state.month}
								mode="month"
								format={date => moment(date).format("YYYY-MM")}
								onChange={this.myAttendanceMonthChange}>
								<List.Item></List.Item>
							</DatePicker>
							<span className="pick-next-month" onClick={this.fetchNextMonthAttendance}>下月</span>
						</List>
						{myAttendanceData && myAttendanceData[0] ?
							<List style={{ backgroundColor: 'white' }} className="picker-list">
								<List.Item extra={this.state.management_date}>月份</List.Item>
								<List.Item extra={myAttendanceData[0].should_attendance_count}>应出勤天数</List.Item>
								<List.Item extra={myAttendanceData[0].actual_attendance_count}>实际出勤天数</List.Item>
								<List.Item extra={myAttendanceData[0].missing_attendance_count}>缺勤天数</List.Item>
								<List.Item extra={myAttendanceData[0].late_count}>迟到次数</List.Item>
								<List.Item extra={myAttendanceData[0].leave_early_count}>早退次数</List.Item>
								<List.Item extra={myAttendanceData[0].attendance_lose}>未打卡次数</List.Item>
								<List.Item extra={myAttendanceData[0].overtime_hours}>加班</List.Item>
								{/*<List.Item extra={myAttendanceData[0].public_hours}>因公加班</List.Item>*/}
								<List.Item extra={myAttendanceData[0].relaxation_hours}>调休小时数</List.Item>
							</List>
							:
							<div>暂无考勤数据</div>
						}
					</div>
				</Tabs>

				<Modal visible={this.state.currentModalStatus} onClose={this.onCancel} title="考勤申诉">
					{this.state.currentData &&
						<List style={{ backgroundColor: 'white' }} className="picker-list">
							<List.Item extra={this.state.currentData.should_attendance_time}>应该出勤时间</List.Item>
							<List.Item extra={this.state.currentData.on_time_str}>签到时间</List.Item>
							<List.Item extra={this.state.currentData.off_time_str}>签出时间</List.Item>
							<TextareaItem
								title="申诉描述"
								placeholder="申诉描述"
								value={this.state.complaint_content}
								rows={5}
								onChange={this.handleChange} />
							<List.Item>
								<div style={{ textAlign: "center" }}>
									<Button type="primary" style={{ width: "120px", marginRight: "15px" }} onClick={this.onSubmit}>保存</Button>
									<Button type="primary" style={{ width: "120px" }} onClick={this.onCancel}>返回</Button>
								</div>
							</List.Item>
						</List>
					}
				</Modal>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		employee: state.employee,
		routing: state.routing,
		user: state.user
	}
}

const mapDispatchToProps = {
	fetchMyAttendanceDetail,
	fetchMyAttendance
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileAttendanceDetail));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileAttendanceDetail.js